<template>
  <div class="goods-3d-h5-setting">
    <el-row class="filter-header" :gutter="20">
      <el-col>
        <el-input
          v-model="params.goods_id"
          class="input-m"
          placeholder="商品ID"
          clearable
          @keyup.enter.native="handleSearch"
        />
        <el-input
          v-model="params.item_name"
          class="input-m"
          placeholder="商品名称"
          clearable
          @keyup.enter.native="handleSearch"
        />
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="tableData" border style="width: 100%; margin-top: 16px">
      <el-table-column prop="goods_id" label="商品ID" width="140" />
      <el-table-column prop="item_name" label="商品名称" min-width="200" />
      <el-table-column prop="h5_3d_url" label="H5地址" min-width="320" />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" class="btn-danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="params.page"
        :page-size="params.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="totalCount"
        @current-change="getList"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="商品名称" prop="item_name">
          <div class="goods-picker-row">
            <el-input
              v-model="form.item_name"
              placeholder="请选择商品"
              readonly
              style="flex: 1"
            />
            <el-button
              v-if="!isEdit"
              type="primary"
              plain
              @click="handlePickGoods"
            >选择商品</el-button>
          </div>
        </el-form-item>
        <el-form-item label="H5地址" prop="h5_3d_url">
          <el-input v-model="form.h5_3d_url" placeholder="请输入H5地址，需以 http:// 或 https:// 开头" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getItem3dh5List,
  createItem3dh5,
  updateItem3dh5,
  deleteItem3dh5
} from '@/api/goods'

const validateH5Url = (rule, value, callback) => {
  const url = (value || '').trim()
  if (!url) {
    callback(new Error('请输入H5地址'))
    return
  }
  if (!/^https?:\/\//i.test(url)) {
    callback(new Error('H5地址必须以 http:// 或 https:// 开头'))
    return
  }
  callback()
}

export default {
  name: 'Goods3dh5setting',
  data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      totalCount: 0,
      params: {
        page: 1,
        pageSize: 10,
        goods_id: '',
        item_name: ''
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        goods_id: '',
        item_name: '',
        h5_3d_url: ''
      },
      rules: {
        item_name: [{ required: true, message: '请选择商品', trigger: 'change' }],
        h5_3d_url: [{ required: true, validator: validateH5Url, trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑' : '新增'
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getListParams() {
      const params = {
        page: this.params.page,
        pageSize: this.params.pageSize
      }
      if (this.params.goods_id) {
        params.goods_id = this.params.goods_id
      }
      if (this.params.item_name) {
        params.item_name = this.params.item_name
      }
      return params
    },
    getList() {
      this.loading = true
      getItem3dh5List(this.getListParams()).then(res => {
        const data = res.data.data || {}
        this.tableData = data.list || []
        this.totalCount = data.total_count || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.params.page = 1
      this.getList()
    },
    handleSizeChange(size) {
      this.params.pageSize = size
      this.params.page = 1
      this.getList()
    },
    resetForm() {
      this.form = {
        goods_id: '',
        item_name: '',
        h5_3d_url: ''
      }
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleAdd() {
      this.resetForm()
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = {
        goods_id: row.goods_id,
        item_name: row.item_name,
        h5_3d_url: row.h5_3d_url
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteItem3dh5(row.goods_id).then(() => {
          this.$message.success('删除成功')
          if (this.tableData.length === 1 && this.params.page > 1) {
            this.params.page -= 1
          }
          this.getList()
        })
      }).catch(() => {})
    },
    async handlePickGoods() {
      const { data } = await this.$picker.goods({
        data: this.form.goods_id ? [this.form.goods_id] : [],
        multiple: false
      })
      if (!data || !data.length) return
      const item = data[0]
      this.form.goods_id = item.goods_id
      this.form.item_name = item.itemName || item.item_name || item.title || ''
      this.$refs.form && this.$refs.form.validateField('item_name')
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const h5_3d_url = this.form.h5_3d_url.trim()
        this.submitLoading = true
        const request = this.isEdit
          ? updateItem3dh5(this.form.goods_id, { h5_3d_url })
          : createItem3dh5({ goods_id: this.form.goods_id, h5_3d_url })
        request.then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.getList()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    handleDialogClose() {
      this.resetForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-3d-h5-setting {
  padding: 16px;
  background: #fff;

  .input-m {
    width: 200px;
    margin-right: 8px;
  }

  .btn-danger {
    color: #f56c6c;
  }

  .pager {
    margin-top: 12px;
    text-align: right;
  }

  .goods-picker-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
